module.exports = __webpack_public_path__ + "static/media/3.647e6595.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank/zsbank/3.png
// module id = 2701
// module chunks = 2